import update from 'immutability-helper'

import { deleteItemById, updateItem } from '../../helpers/reducerHelpers'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV,
  EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV_SUCCESS,
  EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV_FAILURE,
  CLEAR_EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV,
  GET_COMBINED_CAMPAIGNS,
  GET_COMBINED_CAMPAIGNS_SUCCESS,
  GET_COMBINED_CAMPAIGNS_FAILURE,
  CLEAR_COMBINED_CAMPAIGNS,
  UPDATE_COMBINED_CAMPAIGN,
  GET_COMBINED_LINE_ITEMS,
  GET_COMBINED_LINE_ITEMS_SUCCESS,
  GET_COMBINED_LINE_ITEMS_FAILURE,
  CLEAR_COMBINED_LINE_ITEMS,
  GET_COMBINED_GRAPHS,
  GET_COMBINED_GRAPHS_SUCCESS,
  GET_COMBINED_GRAPHS_FAILURE,
  CLEAR_COMBINED_GRAPHS,
  GET_COMBINED_SEGMENTED_DATA,
  GET_COMBINED_SEGMENTED_DATA_SUCCESS,
  GET_COMBINED_SEGMENTED_DATA_FAILURE,
  CLEAR_COMBINED_SEGMENTED_DATA,
  GET_COMBINED_ADS,
  GET_COMBINED_ADS_SUCCESS,
  GET_COMBINED_ADS_FAILURE,
  CLEAR_COMBINED_ADS,
  SET_COMBINED_DATA_DATE_RANGE,
  UPDATE_COMBINED_LINE_ITEM,
  DELETE_COMBINED_CAMPAIGN,
  DELETE_COMBINED_LINE_ITEM
} from '../actions/combinedData'

import { INITIAL_CREATE_REDUCER, INITIAL_GET_REDUCER, INITIAL_GET_RESULTS_REDUCER } from '../../constants/reducer'
import { DATE_STATIC_PRESET, LIFETIME_DATE_PRESET } from '../../constants/selectLists/listItemFiltersList'
import { AMOUNT_MICROS, CAMPAIGN_BUDGET } from '../../forms/Multiplatform/CampaignForms/fields'
import { GOOGLE_PROVIDER_PLATFORM, TIKTOK_PLATFORM } from '../../constants/selectLists/platformList'
import { DELETE_COMBINED_AD } from '../actions/ads'
import { BUDGET_MODE_DAY, BUDGET_MODE_TOTAL, BUYING_TYPE } from '../../forms/Tiktok/fields'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  combinedCampaigns: INITIAL_GET_REDUCER,
  combinedLineItems: INITIAL_GET_RESULTS_REDUCER,
  combinedGraphs: INITIAL_GET_RESULTS_REDUCER,
  combinedSegmentedData: INITIAL_GET_REDUCER,
  combinedAds: INITIAL_GET_RESULTS_REDUCER,
  dateRange: { [DATE_STATIC_PRESET]: LIFETIME_DATE_PRESET },
  exportCombinedCampaignsDataAsCsv: INITIAL_CREATE_REDUCER
}

export default function reports(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    // combined campaigns
    case GET_COMBINED_CAMPAIGNS:
      return update(state, {
        combinedCampaigns: {
          $merge: {
            isLoading: true
          }
        }
      })

    case GET_COMBINED_CAMPAIGNS_SUCCESS:
      const isDatePresetLifetime = action.datePreset === LIFETIME_DATE_PRESET
      return update(state, {
        combinedCampaigns: {
          $merge: {
            ...(isDatePresetLifetime && {
              // We need to store lifetime combinedCampaigns data separately,
              // because we need to have access to 'spend' field for the whole lifetime period
              // We use 'spend' in combinedCampaignBudgetEdit form to calculate "calculated impressions"
              lifetimeDatePresetCombinedCampaigns: action.campaignsData
            }),
            isLoading: false,
            wasLoaded: true,
            data: action.campaignsData
          }
        }
      })
    case GET_COMBINED_CAMPAIGNS_FAILURE:
      return update(state, {
        combinedCampaigns: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_COMBINED_CAMPAIGNS:
      return update(state, {
        combinedCampaigns: {
          $set: initialState.combinedCampaigns
        }
      })

    case UPDATE_COMBINED_CAMPAIGN:
      let updatedCampaign
      if (action.campaignData?.provider === GOOGLE_PROVIDER_PLATFORM) {
        // Google campaign budget form has different payload, so we need to format it before updating combined campaigns
        const budgetDaily = action.campaignData?.[CAMPAIGN_BUDGET]?.[AMOUNT_MICROS]
        updatedCampaign = {
          ...action.campaignData,
          ...(budgetDaily && { budget_daily: budgetDaily })
        }
      } else {
        updatedCampaign = action.campaignData
      }
      return update(state, {
        combinedCampaigns: {
          data: {
            campaigns: {
              $apply: items => updateItem(items, updatedCampaign)
            }
          }
        }
      })

    // combined line items
    case GET_COMBINED_LINE_ITEMS:
      return update(state, {
        combinedLineItems: {
          $merge: {
            isLoading: true,
            // reset error when request new data, this is needed when using date range filter
            error: null
          }
        }
      })
    case GET_COMBINED_LINE_ITEMS_SUCCESS:
      const dateFrom = action.dateRange?.date_from
      const dateTo = action.dateRange?.date_to

      const lifetimeCampaignDateFrom =
        state.combinedCampaigns.lifetimeDatePresetCombinedCampaigns?.campaigns_date_range?.date_from
      const lifetimeCampaignDateTo =
        state.combinedCampaigns.lifetimeDatePresetCombinedCampaigns?.campaigns_date_range?.date_to
      const isLifetime = dateFrom === lifetimeCampaignDateFrom && dateTo === lifetimeCampaignDateTo

      return update(state, {
        combinedLineItems: {
          $merge: {
            ...(isLifetime && {
              // We need to store lifetime lineItems data separately,
              // because we need to have access to 'spend' field for the whole lifetime period
              // We use 'spend' in combinedCampaignBudgetEdit form to calculate "calculated impressions"
              lifetimeDatePresetCombinedLineItems: action.lineItemsData
            }),
            isLoading: false,
            wasLoaded: true,
            results: action.lineItemsData
          }
        }
      })
    case GET_COMBINED_LINE_ITEMS_FAILURE:
      return update(state, {
        combinedLineItems: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_COMBINED_LINE_ITEMS:
      return update(state, {
        combinedLineItems: {
          $set: initialState.combinedLineItems
        }
      })

    case UPDATE_COMBINED_LINE_ITEM:
      const combinedLineItemsGroupedByCampaigns = state.combinedLineItems
      const parentCampaign = combinedLineItemsGroupedByCampaigns.results.find(campaign =>
        campaign.line_items.find(lineItem => String(lineItem.id) === String(action.lineItemData.id))
      )

      const lineItems = parentCampaign.line_items || []

      let updatedParentCampaign = { ...parentCampaign }
      const combinedCampaign = state.combinedCampaigns.data.campaigns.find(
        campaign => String(campaign.id) === String(parentCampaign.campaign_id)
      )
      let updatedCombinedCampaign = { ...combinedCampaign }

      if (action.platform === TIKTOK_PLATFORM) {
        const updatedLineItems = updateItem(lineItems, action.lineItemData)
        const updatedLineItemsBudgetLifetime = updatedLineItems.reduce((acc, item) => {
          return item[BUYING_TYPE] === BUDGET_MODE_TOTAL ? acc + Number(item.budget) : acc
        }, 0)

        const updatedLineItemsBudgetDaily = updatedLineItems.reduce((acc, item) => {
          return item[BUYING_TYPE] === BUDGET_MODE_DAY ? acc + Number(item.budget) : acc
        }, 0)

        updatedParentCampaign = {
          ...parentCampaign,
          line_items: updatedLineItems
        }

        updatedCombinedCampaign = {
          ...combinedCampaign,
          budget_lifetime_line_item: updatedLineItemsBudgetLifetime,
          budget_daily_line_item: updatedLineItemsBudgetDaily
        }
      } else {
        const updatedLineItems = updateItem(lineItems, action.lineItemData)
        const updatedLineItemsBudgetLifetime = updatedLineItems.reduce((acc, item) => {
          return acc + Number(item.budget_lifetime)
        }, 0)

        const updatedLineItemsBudgetDaily = updatedLineItems.reduce((acc, item) => {
          return acc + Number(item.budget_daily)
        }, 0)

        updatedParentCampaign = {
          ...parentCampaign,
          line_items: updatedLineItems
        }

        updatedCombinedCampaign = {
          ...combinedCampaign,
          budget_lifetime_line_item: updatedLineItemsBudgetLifetime,
          budget_daily_line_item: updatedLineItemsBudgetDaily
        }
      }

      return update(state, {
        combinedCampaigns: {
          data: {
            campaigns: {
              $apply: items => updateItem(items, updatedCombinedCampaign)
            }
          }
        },
        combinedLineItems: {
          results: {
            $apply: items => updateItem(items, updatedParentCampaign)
          }
        }
      })

    // combined graphs
    case GET_COMBINED_GRAPHS:
      return update(state, {
        combinedGraphs: {
          $merge: {
            isLoading: true,
            // reset error fields when request new data, this is needed when using date range filter
            error: null
          }
        }
      })
    case GET_COMBINED_GRAPHS_SUCCESS:
      return update(state, {
        combinedGraphs: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.graphsData
          }
        }
      })
    case GET_COMBINED_GRAPHS_FAILURE:
      return update(state, {
        combinedGraphs: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_COMBINED_GRAPHS:
      return update(state, {
        combinedGraphs: {
          $set: initialState.combinedGraphs
        }
      })

    // combined segmented data
    case GET_COMBINED_SEGMENTED_DATA:
      return update(state, {
        combinedSegmentedData: {
          $merge: {
            isLoading: true,
            // reset some state fields when request new data, this is needed when using date range filter
            error: null,
            wasLoaded: false
          }
        }
      })
    case GET_COMBINED_SEGMENTED_DATA_SUCCESS:
      return update(state, {
        combinedSegmentedData: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.segmentedData
          }
        }
      })
    case GET_COMBINED_SEGMENTED_DATA_FAILURE:
      return update(state, {
        combinedSegmentedData: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_COMBINED_SEGMENTED_DATA:
      return update(state, {
        combinedSegmentedData: {
          $set: initialState.combinedSegmentedData
        }
      })

    // combined ads
    case GET_COMBINED_ADS:
      return update(state, {
        combinedAds: {
          $merge: {
            isLoading: true,
            // reset some state fields when request new data, this is needed when using date range filter
            error: null,
            wasLoaded: false
          }
        }
      })
    case GET_COMBINED_ADS_SUCCESS:
      return update(state, {
        combinedAds: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.adsData
          }
        }
      })
    case GET_COMBINED_ADS_FAILURE:
      return update(state, {
        combinedAds: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_COMBINED_ADS:
      return update(state, {
        combinedAds: {
          $set: initialState.combinedAds
        }
      })

    // date range
    case SET_COMBINED_DATA_DATE_RANGE:
      return update(state, {
        dateRange: { $set: action.dateRange }
      })

    // Export combined campaigns data as csv
    case EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV:
      return update(state, {
        exportCombinedCampaignsDataAsCsv: { $merge: { isLoading: true } }
      })
    case EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV_SUCCESS:
      return update(state, {
        exportCombinedCampaignsDataAsCsv: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV_FAILURE:
      return update(state, {
        exportCombinedCampaignsDataAsCsv: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV:
      return update(state, {
        exportCombinedCampaignsDataAsCsv: { $set: initialState.exportCombinedCampaignsDataAsCsv }
      })

    case DELETE_COMBINED_CAMPAIGN:
      return update(state, {
        combinedCampaigns: {
          data: {
            campaigns: {
              $apply: items => deleteItemById(items, action.id)
            }
          }
        }
      })

    case DELETE_COMBINED_LINE_ITEM:
      return update(state, {
        combinedLineItems: {
          results: {
            $apply: items => {
              const parentCampaign = items.find(item => {
                return item.line_items.some(lineItem => lineItem.id === action.lineItemId)
              })
              const updatedLineItems = parentCampaign.line_items.filter(item => item.id !== action.lineItemId)
              const updatedParentCampaign = {
                ...parentCampaign,
                line_items: updatedLineItems
              }
              return items.map(item => {
                if (item.campaign_id === parentCampaign.campaign_id) {
                  return updatedParentCampaign
                }
                return item
              })
            }
          }
        },
        // When delete line item, we need to remove ads from deleted line item as well
        combinedAds: {
          results: {
            $apply: items => {
              // remove ads from deleted line item
              return items.filter(item => item.line_item_id === action.lineItemId)
            }
          }
        }
      })
    case DELETE_COMBINED_AD:
      return update(state, {
        combinedAds: {
          results: {
            $apply: items => items.filter(item => item.id !== action.adId)
          }
        }
      })

    default:
      return state
  }
}
